module.exports = __webpack_public_path__ + "img/character-center.ec3ec320.svg";